import './sass/style.scss'
import './css/tailwind.css'
import './sass/partials/_utility.scss'

import allJs from './js/index'
allJs()



// WEBPACK FOOTER //
// ./src/site.js